// @flow

import * as React from 'react'

import { getMonthsFromNow, getPercentOfMonth, getShortMonth, parseDate } from '../../utils/parsingUtils'

import type DailyItemsApp  from '../../utils/dailyItemsApp'
import type { DivRefType } from 'react-helper'

import './navbar.css'

const classNames = require('classnames');

type PropsType = {
  DailyItemApp: DailyItemsApp,
  navbarContainerRef: DivRefType,
  selectorPos: number,
  setNavbarClicked: (?MouseEvent, boolean) => void,
  navbarClicked: boolean,
  navMouse: boolean
}

type StateType = {
  months: Array<string>,
  percentOfMonth: number,
  percentOfYear: number,
  selectorPos: string,
  dragged: boolean,
  down: boolean
}

export default class Navbar extends React.Component<PropsType, StateType> {
  constructor(props: PropsType) {
    super(props)
    const months = getMonthsFromNow(props.DailyItemApp.keys[props.DailyItemApp.keys.length - 1])
    const uid = this.props.DailyItemApp.getDailyItem().uid
    const percentOfMonth = 100 - this.getFormattedPercentOfMonth(uid)
    const percentOfYear = this.getPercentOfYear(uid, months)
    
    this.state = {
      months,
      percentOfMonth,
      percentOfYear,
      selectorPos: this.getSelectorPos(percentOfMonth, percentOfYear, false),
      dragged: false,
      down: false
    }
  }

  componentDidMount () {
    const selectorPos = this.getSelectorPos(this.state.percentOfMonth, this.state.percentOfYear, false)
    this.setState({ selectorPos })
    window.addEventListener('mouseup', () => {
      this.setState({
        down: false, 
        dragged: false
      });
    });
  }

  componentDidUpdate (prevProps: PropsType, prevState: StateType) {
    const uid = this.props.DailyItemApp.getDailyItem().uid
    const percentOfMonth = this.getFormattedPercentOfMonth(uid)
    if (prevProps.selectorPos !== this.props.selectorPos) {
      const selectorPos = this.getSelectorPos(this.state.percentOfMonth, this.state.percentOfYear, true)
      this.setState({ selectorPos })
    } else if (percentOfMonth !== prevState.percentOfMonth && !this.props.navbarClicked) {
      const percentOfYear = this.getPercentOfYear(uid, this.state.months)
      const selectorPos = this.getSelectorPos(percentOfMonth, percentOfYear, false)
      this.setState({ percentOfMonth, percentOfYear, selectorPos })
    }
  }

  getSelectorPos = (percentOfMonth: number, percentOfYear: number, fromProps: boolean): string =>
    fromProps
      ? `${this.props.selectorPos}px`
      : `calc(${percentOfMonth + percentOfYear} * 100% / 100)`

  getFormattedPercentOfMonth = (uid: string) =>
    (100 - getPercentOfMonth(uid)) / 12

  getPercentOfYear = (uid: string, months: Array<string>) => {
    const currentMonth = parseDate(uid)
    const index = months.indexOf(currentMonth.formattedMonth)
    return (100 / 12) * index
  }

  displayMonths = (months: Array<string>): Array<React.Node> => (
    months.map((month: string): React.Node => (
      <h3 className="navbar-months" key={month}>{getShortMonth(month)}</h3>
    ))
  )

  render() {
    const styles = classNames({
      'navbar-container' : true,
      'navbar-dragged': this.props.navMouse,
    })

    const navbarState = classNames({
      'navbar-selected': true,
      'dragged': this.state.dragged,
    })

    return (
      <div
        className={styles}
        ref={this.props.navbarContainerRef}
      >
        <div className="navbar-months">
          {this.displayMonths(this.state.months)}
        </div>
        <div 
          className="navbar-body"
          onMouseDown={(e: MouseEvent) => { 
            this.props.setNavbarClicked(e, true)
            this.setState({
              dragged : true,
              down: true
            })
          }}
          onMouseUp={(e: MouseEvent) => { 
            this.props.setNavbarClicked(undefined, false)
            this.setState({
              dragged : false,
              down: false
            })
          }}
          onMouseLeave={(e) => {
            if(!this.state.down) this.setState({dragged : false})
          }}
        />
        <div 
          className="navbar-slider"
          onMouseDown={(e: MouseEvent) => { 
            this.props.setNavbarClicked(e, true)
            this.setState({
              dragged : true,
              down: true
            })
          }}
          onMouseUp={(e: MouseEvent) => { 
            this.props.setNavbarClicked(undefined, false)
            this.setState({
              dragged : false,
              down: false
            })
          }}
          onMouseLeave={(e) => {
            if(!this.state.down) this.setState({dragged : false})
          }}

        >
          <div className="navbar-dot" style={{ top: this.state.selectorPos }}> {/* @TODO Circle moves too fast */}
            <div className={navbarState}></div>
          </div>
        </div>
        <div className="navbar-selector" style={{ height: this.state.selectorPos }}/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Home/navbar.jsx